module.exports = __webpack_public_path__ + "img/已结束.0d85d26b.png";